<template>
  <div>
    <section class="title">
      <div class="header__text-box">
        <h1 class="heading-primary">
          <span class="heading-primary--main">User Administration
          </span>
        </h1>
      </div>
    </section>
    <Crumbs />

    <section class="section-admin">
      <span v-if="users && usersAuth">
        <table class="table table-striped">
          <thead>
            <tr>
              <th scope="col">#</th>
              <th scope="col">Email</th>
              <th scope="col">Last login</th>
              <th scope="col">Role</th>
              <th scope="col">Delete</th>
              <th scope="col">Disable</th>
              <th scope="col">Password Reset Email</th>
              <th scope="col">Reset Password Override</th>
            </tr>
          </thead>
          <tbody>
            <tr
              v-for="(mappeduser, index) in mappedUsers"
              :key="mappeduser.uid"
            >
              <td>{{ mappeduser.uid }}</td>
              <td>{{ mappeduser.email }}</td>
              <td>{{ mappeduser.lastLogin }}</td>
              <td>
                <select
                  class="selectpicker"
                  @change="changeRole(mappeduser.uid, $event)"
                >
                  <option
                    :selected="mappeduser.role.superadmin"
                    value="admin"
                  >SuperAdmin</option>
                  <option
                    :selected="mappeduser.role.admin"
                    value="admin"
                  >Admin</option>
                  <option
                    :selected="mappeduser.role.customer"
                    value="customer"
                  >Customer</option>
                </select>
              </td>
              <!-- <td><button type="button"  v-on:click="temp(mappeduser.uid)" class="btn btn-danger">Delete</button></td> -->
              <td><button
                type="button"
                class="btn btn-tiled tertiary"
                @click="deleteUser(mappeduser.uid)"
              >Delete</button></td>
              <td>
                <span v-if="mappeduser.disabled === true"> <button
                  type="button"
                  class="btn btn-tiled primary"
                  @click="enableUser(mappeduser.uid, index)"
                >Enable</button></span>
                <span v-if="mappeduser.disabled === false"><button
                  type="button"
                  class="btn btn-tiled tertiary"
                  @click="disableUser(mappeduser.uid, index)"
                >Disable</button></span>
              </td>
              <td><button
                type="button"
                class="btn btn-tiled primary"
                @click="resetUserPasswordEmail(mappeduser.uid)"
              >Send Email</button></td>
              <td><button
                type="button"
                class="btn btn-tiled primary"
                @click="showResetModal(mappeduser.uid, index)"
              >Reset Pwd</button></td>
            </tr>
          </tbody>

          <div v-if="showModalResetPassword">
            <transition name="modal">
              <div class="modal-mask">
                <div class="modal-wrapper">
                  <div
                    class="modal-dialog"
                    role="document"
                  >
                    <div class="modal-content">
                      <div class="modal-header">
                        <h5 class="modal-title">You are about to reset the password for {{ selectedUser.email }}</h5>
                        <button
                          type="button"
                          class="close"
                          data-dismiss="modal"
                          aria-label="Close"
                        >
                          <span
                            aria-hidden="true"
                            @click="showModalResetPassword = false"
                          >&times;</span>
                        </button>
                      </div>
                      <div class="modal-body">
                        <p>It is strongly recommended that the user resets their own password through password recovery.<br> An email will notify the user of the change of password. <br> <b> The password will be reset to:{{ randompasswordstring }} </b></p>
                      </div>
                      <div class="modal-footer">
                        <button
                          type="button"
                          class="btn btn-secondary"
                          @click="showModalResetPassword = false"
                        >Close</button>
                        <button
                          type="button"
                          class="btn btn-primary"
                          @click="resetUserPassword(selectedUser.uid, randompasswordstring)"
                        >Proceed</button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </transition>
          </div>

        </table>
      </span>
    </section>
  </div>
</template>
<script>
import Crumbs from '@/components/layout/Crumbs'
export default {
  components: {
    Crumbs
  },
  data () {
    return {
      users: [],
      user: null,
      usersAuth: null,
      selecteduser: null,
      showModalResetPassword: false,
      randompasswordstring: null
    }
  },
  computed: {
    mappedUsers: function () {
      // map the user objects into one object in an  useable array
      const filteredArray = []

      for (let i = 0; i < this.users.length; i++) {
        let newdata = []
        newdata.push(this.users[i], this.usersAuth[i])
        newdata = Object.assign(...newdata)
        filteredArray.push(newdata)
      }
      const filterElements = filteredArray.map((user) => {
        return ({ uid: user.id, email: user.email, disabled: user.disabled, role: user.role, lastLogin: user.metadata.lastSignInTime })
      })
      return filterElements
    }

  },

  created () {
    // call all users from the firebase store.
    this.getUserAuth()
    this.getUserInfo()
    this.rndStr()
  },
  methods: {
    showResetModal (uid, index) {
      this.randompasswordstring = this.rndStr(13)
      this.selectedUser = this.mappedUsers[index]
      this.showModalResetPassword = true
    },
    rndStr (len) {
      let text = ''
      const chars = 'abcdefghijklmnopqrstuvwxyz123456789#~[]=-+_()*&^%$£"!ABCDEFGHIJKLMNOPQRSTUVQWXYZ'

      for (let i = 0; i < len; i++) {
        text += chars.charAt(Math.floor(Math.random() * chars.length))
      }

      return text
    },
    getUserInfo () {
      this.users = []
      firebase
        .firestore()
        .collection('roles')
        .get()
        .then(snap => {
          snap.forEach(doc => {
            const user = doc.data()
            user.id = doc.id
            this.users.push(user)
          })
        })
    },
    getUserAuth () {
      const addMessage = firebase.functions().httpsCallable('listAllUsers')
      addMessage()
        .then(result => {
          this.usersAuth = result.data.users
        })

      firebase.auth().onAuthStateChanged((user) => {
        this.user = user
      })
    },
    changeRole (uid, event) {
      const addMessage = firebase.functions().httpsCallable('setUserRole')
      const data = { uid: uid, role: { [event.target.value]: true } }

      addMessage(data)
        .then(function (result) {
          console.log(result)
        })
        .catch(function (error) {
          console.log(error)
        })
    },
    resetUserPassword (uid, randompasswordstring) {
      const addMessage = firebase.functions().httpsCallable('resetUserPassword')
      const data = { uid: uid, password: randompasswordstring }
      console.log(addMessage, data)
      addMessage(data)
        .then(function (result) {
          console.log(result)
        })
        .catch(function (error) {
          console.log(error)
        })
    },
    resetUserPasswordEmail (id) {
      const found = this.mappedUsers.find(uid => uid.uid === id)
      console.log(found.email)
      firebase.auth().sendPasswordResetEmail(found.email).then(() => {
        console.log('email sent!')
      })
    },
    deleteUser (uid) {
      const addMessage = firebase.functions().httpsCallable('deleteUser')
      const data = { uid: uid }
      console.log(data)

      addMessage(data)
        .then(() => {
          this.users = this.users.filter(user => user.user_id !== uid)
          console.log(this.users)
        })
        .catch(function (error) {
          console.log(error)
        })
    },
    disableUser (uid, index) {
      const addMessage = firebase.functions().httpsCallable('disableUser')
      const data = { uid: uid }
      addMessage(data)
        .then(() => {
          this.usersAuth[index].disabled = true
          this.mappedUsers[index].disabled = true
          console.log(uid, index)
          console.log(this.mappedUsers[index].disabled)
        })
        .catch(function (error) {
          console.log(error)
        })
    },
    enableUser (uid, index) {
      const addMessage = firebase.functions().httpsCallable('enableUser')
      const data = { uid: uid }
      addMessage(data)
        .then(() => {
          console.log(this.usersAuth[index])
          this.usersAuth[index].disabled = false
          this.mappedUsers[index].disabled = false
          console.log(this.mappedUsers[index].disabled)
        })
        .catch(function (error) {
          console.log(error)
        })
    }
  }
}
</script>

<style>
  .modal-mask {
  position: fixed;
  z-index: 9998;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, .5);
  display: table;
  transition: opacity .3s ease;
}

.modal-wrapper {
  display: table-cell;
  vertical-align: middle;
}
</style>
